export default __webpack_public_path__ + "static/media/photo 1.fae543ab.jpg";